export default __webpack_public_path__ + "static/media/tyre.305cea50.svg";